import { useContext } from "react";
import { CustomModal, UserInformation } from "../../../../components";
import Context from "../../../../context";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import TitleLine from "../../../../components/TitleLine";
import CustomLeaflet from "../../../../components/CustomLeaflet";

const Detail = () => {
  const { setShowModal, showModal, selectedClient } = useContext(
    Context?.ClientScreen
  );

  console.log(selectedClient);
  return (
    <>
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DETAIL"}
        minWidth={"30vw"}
        maxWidth={"35vw"}
      >
        <Row className="modal-user-info">
          <Column>
            <UserInformation
              avatar={selectedClient?.avatar}
              name={selectedClient?.firstName}
              lastName={selectedClient?.lastName}
              phoneNumber={selectedClient?.phoneNumber}
            />
          </Column>
        </Row>
        <TitleLine title="" />
        <Row className="modal-user-info">
          <Column>
            <CustomLeaflet
              defaultLat={selectedClient?.address?.[0]?.lat}
              defaultLng={selectedClient?.address?.[0]?.lng}
            />
          </Column>
        </Row>
      </CustomModal>
    </>
  );
};

export default Detail;
